<template>
  <screen
    v-show="show"
    :screen-info="$t('footscan.sit')"
    :can-skip="false"
    :can-leave="false"
    @skip="$emit('skip')"
  >
    <img src="../../assets/FootScan/knee-90.svg" :alt="$t('footscan.sit')" />
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import Screen from '../common/Screen.vue';

export default {
  name: 'Sit',
  mixins: [autoNext],
  components: {
    Screen,
  },
  data: () => ({
    playThroughGap: 3,
    audioKey: 'foot_sit',
  }),
};
</script>

<style scoped></style>
